import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { SETTINGS_MODE } from 'shared/enums';
import { IMyKnownError, REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { clearNavigationActions } from './helpers';
import { ISettingsNavigationState } from './interfaces';

export const initialState: ISettingsNavigationState = {
  mode: SETTINGS_MODE.users,
  loading: REQUEST_LIFE_CICLE.IDLE,
};

export const setSettingsNavigationAction = createAsyncThunk<
  SETTINGS_MODE,
  SETTINGS_MODE,
  { rejectValue: IMyKnownError }
>('settingsModeNavigation/set', async (payload, { dispatch }) => {
  dispatch(clearNavigationActions[payload]());
  return payload;
});

export const resetSettingsAction = createAsyncThunk<
  ISettingsNavigationState,
  undefined,
  { rejectValue: IMyKnownError }
>('settingsModeNavigation/reset', async (_, { dispatch }) => {
  dispatch(clearNavigationActions[initialState.mode]());
  return initialState;
});

const settingsNavigationSlice = createSlice({
  name: 'settingsNavigation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setSettingsNavigationAction.fulfilled,
      (state, { payload }) => {
        state.mode = payload;
        return state;
      },
    );
    builder.addCase(resetSettingsAction.fulfilled, (state, { payload }) => {
      state.mode = payload.mode;
      state.loading = payload.loading;
      return state;
    });
  },
});
const { reducer } = settingsNavigationSlice;
export default reducer;
